// import { useEnsureLogged } from '@/hooks';
import cls from 'classnames';
import styles from './index.module.scss';
import Banner from './Banner';
import HomeProducts from './HomeProducts';
// import HotIP from './HotIP';
import Entry from './Entry';
import Notice from './Notice';
import { useProductKinds } from '@/stores';

const Home = () => {
  const { homeProductKindList } = useProductKinds();

  // const click = useEnsureLogged(() => {
  //   console.log('当前操作需要登录');
  // }, []);
  return (
    <div className={styles.container}>
      <Notice />
      <Banner />
      <div className={cls('container')}>
        <Entry />
        {/* <HotIP /> */}
        {!!homeProductKindList &&
          homeProductKindList.map((item) => (
            <HomeProducts key={item.id} info={item} />
          ))}
      </div>
    </div>
  );
};

export default Home;
